<template>
  <div
    class="column-list section"
    :style="sectionStyle"
  >
    <div class="container q-gutter-y-xl">
      <div
        class="text-center"
        :style="titleStyle"
        v-html="$options.filters.pureHtml(title)"
      />

      <ul v-if="items.length > 0">
        <li
          v-for="(item, index) in items"
          :key="index"
          :style="descriptionStyle"
        >
          {{ item.description }}
        </li>
      </ul>

      <div class="flex justify-center">
        <CTAButton v-bind="cta"/>
      </div>
    </div>
  </div>
</template>

<script>
import CTAButton from './CTAButton';
import backgroundMixin from './mixins/backgroundMixin';
import descriptionMixin from './mixins/descriptionMixin';
import popupMixin from './mixins/popupMixin';
import titleMixin from './mixins/titleMixin';

export default {
  name: 'ColumnListSection',
  components: { CTAButton },
  mixins: [
    backgroundMixin,
    descriptionMixin,
    titleMixin,
    popupMixin,
  ],
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    cta: {
      type: Object,
      required: true,
    },
  },
};
</script>
